import React, { useState, useEffect } from 'react'
import ContentWrapper from '../layouts/contentWrapper'
import Filter from '../../components/Filter';
import Loading from '../../components/Loading';
import ModalScheduling from '../modals/modal-scheduling';
import Grid from '../../components/Grid';
import api from '../../services/api'
import ShowMessages from '../../components/Exceptions'
import setStatistic from '../../services/apiStatistic'
import {checkPermission} from '../../components/security'
import { format   }        from 'date-fns'
import Swal from 'sweetalert2'

export default function Scheduling() {
    const [loading, setLoading]                            = useState(false)
    const [showModal, setShowModal]                        = useState(false)
    const [isOpenFilter, setIsOpenFilter]                  = useState(false)
    const [reload, setReload]                              = useState(false)
    const [print, setPrint]                                = useState(false)
    const [excel, setExcel]                                = useState(false)
    const [showButtons, setShowButtons]                    = useState(false)
    const [editState, setEditState]                        = useState(false)
    const [gridParams, setGridParams]                      = useState({})
    const [data, setData]                                  = useState({})
    const [filters, setFilters]                            = useState([])
    const [editPermission, setEditPermisson]               = useState(false)
    const [startDate, setStartDate]                        = useState(format(new Date(),'yyyy-MM-dd'))
    const [endDate, setEndDate]                            = useState(format(new Date(),'yyyy-MM-dd'))

    const handleSearch = async() => {
        let _filters = [{ field      : 'datascheduling',
                          key        : 'between',  
                          value      : startDate,
                          value2     : endDate,
                          ignoretime : true   
                        }]

        
        setFilters(_filters)
    }

    const getScheduling = async() => {
        await api.get('/scheduling-status/0')
                 .then(response => {
                    let _delCheck  = !checkPermission(2,35)
                    let _editCheck = !checkPermission(4,35)
                    setEditPermisson(_editCheck)

                    setGridParams({idscheduling     : {text       : "#ID", mask : { name  : 'leftSlice',
                                                                                    value : '00000'},
                                                       primaryKey  : true                          },
                                   schedulingservice: {text        : "Serviço"},
                                   name             : {text        : "Nome",
                                                       searchDefault : true},
                                   phone            : {text        : "Telefone"},
                                   email            : {text        : "Email"},
                                   datascheduling   : {text        : "Data do Agendamento",
                                                       dataType    : "date",
                                                       ignoretime  : true},
                                   arrival_date     : {text        : "Data Chegada",
                                                       dataType    : "date",
                                                       ignoretime  : true},
                                   schedulingstatus : {text        : "Status",
                                                       item        : {className : "text-center",
                                                       switch      : {data  : response.data,
                                                                      key   : 'idschedulingstatus'}}},
                                   comments         : {text        : "Observações",
                                                       props       : {maxLength   : 30,
                                                                      fieldTitle  : true}}, 
                                   Options          : {text        : "Opções",
                                                       className   : "text-center",
                                                       order       : false,
                                                       filter      : false,
                                                       item        : [{type  : "Custom",
                                                                       props : {tag            : "button",
                                                                                title          : "Exclusão de agendamento",
                                                                                className      : 'btn btn-sm btn-danger',
                                                                                icon           : "fa fa-trash",
                                                                                disabled       : _delCheck,
                                                                                message        : "Deseja realmente excluir o agendamento?",
                                                                                indexcallback  : 0}},
                                                                      {type  : "Custom",
                                                                       props : {tag            : "button",
                                                                                title          : "Editar agendamento",
                                                                                disabled       : _editCheck,
                                                                                className      : 'btn btn-sm btn-warning',
                                                                                icon           : "fa fa-edit",
                                                                                indexcallback  : 1}}]}                           
                    })
                })
    }

    useEffect(() => {
        handleSearch()
        getScheduling()
        setStatistic('maintenance\\scheduling')
    },[])
    
    const handleCloseModal = () => {setShowModal(false)}
    const handleFilter     = () => {setIsOpenFilter(!isOpenFilter)}

    const RemoveScheduling = async (id) => {     
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente excluir o agendamento?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(async(result) => {
            if (result.isConfirmed) {
                await api.delete('/scheduling/' + id)
                         .then(response => {
                            ShowMessages(response.data)
                            setReload(true)
                         })
                         .catch( error => {
                            ShowMessages(error)
                         })
            }
            
        }) 
    }

    const EditScheduling = async(id) => {
        await api.get('/scheduling/' + id)
                 .then(response => {
                    setData(response.data)
                    setEditState(true)
                    setShowModal(true)
                 })
                 .catch( error => {
                    ShowMessages(error)
                 })
    }

    return (    
        <ContentWrapper>
            <Loading loading={loading}/>
            <ModalScheduling showModal={showModal} handleCloseModal = {handleCloseModal} editState={editState} data={data} handleReload={setReload}/>
            <div className={`container-lg container-100 ${(loading ? "hidden" : "")}`}>
                <div className="content-heading">
                    <div className="box-maintance-buttons">
                        <div>
                            <button className="btn btn-primary" title="Atualizar Dados" style={{marginLeft:"3px"}} onClick={e => setReload(true)}><i className="fa fa-redo"></i></button>
                            {showButtons ? 
                                <>
                                    <button className="btn btn-dark" title="Impressão" onClick={e => setPrint(true)} style={{marginLeft:"3px"}}><i className="fa fa-print"></i></button>
                                    <button className="btn btn-info" disabled={!checkPermission(16,35)} title="Exportar para excel" onClick={e => setExcel(true)} style={{marginLeft:"3px"}}><i className="fa fa-file-excel">    </i></button>
                                    <button className="btn btn-secondary" title="Filtros Avançados" style={{marginLeft:"3px"}} onClick={e => handleFilter()}><i className="fa fa-search-plus"></i></button>
                                </>
                            : "" }
                        </div>
                        <div style={{borderLeft:"1px solid #cacaca", marginLeft:"15px", display:"flex"}}>
                            <div style={{marginLeft:"15px", width:"170px"}}>
                                <span>Data Inicial do Agendamento</span>
                                <input type="date" className='form-control' value={startDate} onChange={e => setStartDate(e.target.value)}/>
                            </div>
                            <div style={{marginLeft:"15px", width:"170px"}}>
                                <span>Data Final do Agendamento</span>
                                <input type="date" className='form-control' value={endDate} onChange={e => setEndDate(e.target.value)}/>
                            </div>
                        </div>
                        <div style={{marginLeft:"15px", display:"flex",alignItems:"center"}}>
                            <button className="btn btn-success" title="Clique aqui para pesquisar" onClick={e => handleSearch(e)}><i className="fa fa-search"/></button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`content-box-cart ${(loading ? "hidden" : "")}`}>
                <Filter isOpenFilter={isOpenFilter} filters={gridParams} callback={setFilters} callBackOpenFilter={handleFilter}/>
                <Grid url                 = '/scheduling' 
                      headers             = {gridParams} 
                      loading             = {setLoading} 
                      reload              = {reload}
                      print               = {print}
                      excel               = {excel}
                      filters             = {filters}
                      filename            = "Agendamentos"
                      callbackShowButtons = {setShowButtons}
                      callbackExcel       = {setExcel}
                      callbackPrint       = {setPrint}
                      callbackReload      = {setReload}
                      callbackCellClick   = {editPermission ? undefined : EditScheduling}
                      callbackButtons     = {[RemoveScheduling, 
                                              EditScheduling]}
                      />  
            </div>                    
        </ContentWrapper>
    )
}